export const acsChatEnvironment = {
  production: false,
  /** Base URL for Azure Function App API */
  apiBaseUrl: 'https://func-acs-chat-poc-dev.azurewebsites.net/api',
  /** Azure Communication Services endpoint */
  acsEndpoint: 'https://acs-im-and-vc.australia.communication.azure.com',
};
